import { FaLock } from "react-icons/fa"; // Import X icon
import "../App.css"; // Import the CSS file

const AccountExpiredMessage = () => {
    return (
        <div className="error-message">
            <FaLock className="lock-icon" />
            <span>
                Your access has expired! <br />
                Please reach out to the admin to renew your access.
            </span>
        </div>
    );
};

export default AccountExpiredMessage;
